/* Harrow Collection theme JS
   Vanilla, no dependencies. Cart drawer via AJAX Cart API + Section Rendering API. */
(function () {
  'use strict';

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || window.theme.moneyFormat || '{{ amount }}';
    var amount;
    if (f.indexOf('amount_no_decimals') !== -1) {
      amount = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount);
    }
    if (f.indexOf('amount_with_comma_separator') !== -1) {
      amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
    }
    return f.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    var els = $$('.reveal', root);
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.dataset.shown = 'true'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.shown = 'true';
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.dataset.shown !== 'true') io.observe(el);
    });
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('#MobileMenu');
    if (!menu) return;
    function setOpen(open) {
      menu.dataset.open = open ? 'true' : 'false';
      document.body.classList.toggle('overflow-locked', open);
      var burger = $('[data-menu-open]');
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    menu.addEventListener('click', function (e) { if (e.target.classList.contains('mobile-menu__overlay')) setOpen(false); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.dataset.open === 'true') setOpen(false); });
  }

  /* ---------- cart drawer ---------- */
  var cart = {
    open: function () {
      var d = $('#CartDrawer');
      if (!d) return;
      d.dataset.open = 'true';
      document.body.classList.add('overflow-locked');
    },
    close: function () {
      var d = $('#CartDrawer');
      if (!d) return;
      d.dataset.open = 'false';
      document.body.classList.remove('overflow-locked');
    },
    refresh: function () {
      return fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawerContent');
          var current = $('#CartDrawerContent');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshCount = doc.querySelector('[data-cart-count-source]');
          if (freshCount) {
            var n = parseInt(freshCount.getAttribute('data-cart-count-source'), 10) || 0;
            cart.updateCount(n);
          }
          bindCartDrawer();
        });
    },
    updateCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('hidden', n === 0);
      });
    },
    addItems: function (items) {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    add: function (id, quantity, properties) {
      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      if (properties && Object.keys(properties).length) body.items[0].properties = properties;
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    change: function (key, quantity) {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }
  };
  window.HarrowCart = cart;

  function bindCartDrawer() {
    var d = $('#CartDrawer');
    if (!d) return;
    $$('[data-cart-close]', d).forEach(function (b) {
      b.onclick = cart.close;
    });
    var ov = $('.cart-drawer__overlay', d);
    if (ov) ov.onclick = cart.close;
    $$('[data-line-remove]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-remove'), 0).then(cart.refresh);
      };
    });
    $$('[data-line-plus]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-plus'), parseInt(b.getAttribute('data-qty'), 10) + 1).then(cart.refresh);
      };
    });
    $$('[data-quick-add]', d).forEach(function (b) {
      b.onclick = function (e) {
        e.preventDefault();
        cart.add(parseInt(b.getAttribute('data-quick-add'), 10), 1)
          .then(function () { return cart.refresh(); })
          .catch(function () { toast('Could not add to basket'); });
      };
    });
    $$('[data-line-minus]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-minus'), Math.max(0, parseInt(b.getAttribute('data-qty'), 10) - 1)).then(cart.refresh);
      };
    });
  }

  function initCartTriggers() {
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        cart.open();
      });
    });
    document.addEventListener('keydown', function (e) {
      var d = $('#CartDrawer');
      if (e.key === 'Escape' && d && d.dataset.open === 'true') cart.close();
    });
  }

  /* ---------- product form (PDP) ---------- */
  function initProductForm() {
    var root = $('[data-product-root]');
    if (!root) return;
    var productData = JSON.parse($('#ProductJson', root).textContent);
    var variants = productData.variants;
    var options = productData.options;

    function currentSelection() {
      var sel = {};
      options.forEach(function (opt, i) {
        var checked = $('[data-option-index="' + i + '"] [aria-pressed="true"]', root);
        if (checked) sel[i] = checked.getAttribute('data-value');
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return options.every(function (opt, i) {
          return v.options[i] === sel[i];
        });
      });
    }

    function updateUI() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      var atc = $('[data-atc]', root);
      var buyNow = $('[data-buy-now]', root);
      var priceEls = $$('[data-price]', root);
      var stickyPrice = $('[data-sticky-price]', root);
      var idInput = $('[data-variant-id]', root);

      options.forEach(function (opt, i) {
        var label = $('[data-option-index="' + i + '"] [data-selected-value]', root);
        if (label) label.textContent = sel[i] || '';
        $$('[data-option-index="' + i + '"] [data-value]', root).forEach(function (btn) {
          var candidate = Object.assign({}, sel);
          candidate[i] = btn.getAttribute('data-value');
          var available = variants.some(function (v) {
            return options.every(function (o, j) { return v.options[j] === candidate[j]; }) && v.available;
          });
          btn.classList.toggle('unavailable', !available);
        });
      });

      if (!variant) return;
      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var skuRow = $('[data-sku-row]', root);
      var skuValue = $('[data-sku]', root);
      var sku = String(variant.sku || '').trim();
      if (skuValue) skuValue.textContent = sku;
      if (skuRow) skuRow.hidden = !sku;
      var soldOut = !variant.available;
      [atc, buyNow].forEach(function (b) { if (b) b.disabled = soldOut; });
      if (atc) {
        $('[data-atc-label]', atc).textContent = soldOut
          ? atc.getAttribute('data-soldout-text')
          : atc.getAttribute('data-add-text') + ' — ' + formatMoney(variant.price);
      }
      /* Which option is the colour? By name first, then by recognising the
         selected value as a colour word in any of the shop languages. */
      var colourIdx = -1;
      options.forEach(function (o, oi) { if (/colou?r|kolor|farbe|colore/i.test(o)) colourIdx = oi; });
      if (colourIdx === -1) {
        options.forEach(function (o, oi) {
          if (colourKeys(sel[oi]).length) colourIdx = oi;
        });
      }
      var vimg = variant.featured_image;
      var vpos = vimg ? parseInt(vimg.position, 10) : 0;
      if (colourIdx >= 0 && window.galleryApplyColour) {
        window.galleryApplyColour(sel[colourIdx], vpos);
      } else if (vpos) {
        gallerySet(vpos - 1);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-value]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        $$('[data-value]', group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        updateUI();
      });
    });

    function collectProperties() {
      var props = {};
      var mono = $('[data-monogram-toggle]', root);
      var initials = $('[data-monogram-input]', root);
      if (mono && mono.checked && initials && initials.value.trim()) {
        props['Engraved initials'] = initials.value.trim().toUpperCase();
        var style = $('[data-engrave-style][aria-pressed="true"]', root);
        props['Engraving style'] = style ? style.getAttribute('data-engrave-style') : 'Classic';
      }
      return props;
    }

    var monoToggle = $('[data-monogram-toggle]', root);
    var monoInput = $('[data-monogram-input]', root);
    var initialsError = null;

    function showInitialsError() {
      if (!monoInput) return;
      if (!initialsError) {
        initialsError = document.createElement('p');
        var form = monoInput.closest('form');
        initialsError.id = (monoInput.id || (form && form.id) || 'harrow-engraving') + '-initials-error';
        initialsError.setAttribute('role', 'alert');
        initialsError.style.cssText = 'display:block;color:#9f2a25;font-size:0.875rem;line-height:1.5;margin:8px 0;';
        monoInput.insertAdjacentElement('afterend', initialsError);
        var describedBy = (monoInput.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (describedBy.indexOf(initialsError.id) === -1) describedBy.push(initialsError.id);
        monoInput.setAttribute('aria-describedby', describedBy.join(' '));
      }
      initialsError.textContent = 'Enter 1–3 letters (A–Z) for your initials.';
      initialsError.hidden = false;
      initialsError.style.display = 'block';
      monoInput.setAttribute('aria-invalid', 'true');
      var wrap = $('[data-monogram-field]', root);
      if (wrap) wrap.classList.remove('hidden');
    }

    function clearInitialsError() {
      if (initialsError) {
        initialsError.hidden = true;
        initialsError.style.display = 'none';
        initialsError.textContent = '';
      }
      if (monoInput) monoInput.removeAttribute('aria-invalid');
    }

    function validateInitials() {
      if (!monoToggle || !monoToggle.checked) {
        clearInitialsError();
        return true;
      }
      if (monoInput && /^[A-Za-z]{1,3}$/.test(monoInput.value)) {
        clearInitialsError();
        return true;
      }
      showInitialsError();
      if (monoInput) monoInput.focus();
      return false;
    }

    if (monoToggle) {
      monoToggle.addEventListener('change', function () {
        var wrap = $('[data-monogram-field]', root);
        if (wrap) wrap.classList.toggle('hidden', !monoToggle.checked);
        if (monoInput) monoInput.required = monoToggle.checked && !monoToggle.disabled;
        clearInitialsError();
      });
    }
    if (monoInput) {
      monoInput.required = !!(monoToggle && monoToggle.checked && !monoToggle.disabled);
      monoInput.addEventListener('input', function () {
        var entered = monoInput.value;
        monoInput.value = entered.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
        if (monoToggle && monoToggle.checked &&
            (!/^[A-Za-z]{1,3}$/.test(entered) || !monoInput.value)) {
          showInitialsError();
        } else {
          clearInitialsError();
        }
      });
      // Native required/pattern validation runs before the form's submit handler.
      monoInput.addEventListener('invalid', function (event) {
        if (!monoToggle || !monoToggle.checked) return;
        event.preventDefault();
        showInitialsError();
        monoInput.focus();
      });
    }

    var purchaseBusy = false;
    function addCurrent(thenCheckout) {
      if (purchaseBusy) return;
      if (!validateInitials()) return;
      var idInput = $('[data-variant-id]', root);
      var variant = variants.find(function (v) { return String(v.id) === idInput.value; });
      if (!variant || !variant.available) return;
      if (productData.has_selling_plans && !validPreorderSelection()) {
        toast('Please select a pre-order payment option before adding this item.'); return;
      }
      var plan = productData.has_selling_plans ? new FormData(productForm).get('selling_plan') : null;
      var engravingToggle = $('[data-monogram-toggle]', root);
      var props = collectProperties();
      var fee = $('[data-engraving-variant]', root);
      var items;
      try {
        items = window.HarrowEngraving.buildItems({
          id: variant.id, plan: plan, title: productData.title,
          engraved: !!(engravingToggle && engravingToggle.checked),
          initials: props['Engraved initials'], style: props['Engraving style'],
          feeId: fee && fee.value
        });
      } catch (error) { toast(error.message); if (monoInput) monoInput.focus(); return; }
      purchaseBusy = true;
      var atc = $('[data-atc]', root);
      if (atc) atc.classList.add('is-loading');
      cart.addItems(items)
        .then(function () {
          if (thenCheckout) { return window.HarrowEngraving.checkCart().then(function () { window.location.href = window.routes.cart_url + '/checkout'; }); }
          return cart.refresh().then(function () {
            cart.open();
            if (atc) {
              var label = $('[data-atc-label]', atc);
              var prev = label.textContent;
              label.textContent = atc.getAttribute('data-added-text');
              setTimeout(function () { updateUI(); }, 2000);
            }
          });
        })
        .catch(function (e) {
          toast((e && e.description) || 'Could not add to basket');
        })
        .then(function () { purchaseBusy = false; if (atc) atc.classList.remove('is-loading'); });
    }

    var productForm = $('.harrow-product-form', root);
    var atcBtn = $('[data-atc]', root);
    var stickyAtc = $('[data-sticky-atc]', root);
    var buyNowBtn = $('[data-buy-now]', root);

    function validPreorderSelection() {
      var variantId = $('[data-variant-id]', root).value;
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      var plans = new FormData(productForm).getAll('selling_plan').filter(function (id) { return id !== ''; });
      var allowed = variant ? variant.selling_plan_ids.map(String) : [];
      return variant && variant.available && plans.length === 1 && allowed.indexOf(String(plans[0])) !== -1;
    }

    if (productForm) productForm.addEventListener('submit', function (e) {
      if (monoToggle && monoToggle.checked) {
        e.preventDefault(); e.stopImmediatePropagation(); addCurrent(false); return;
      }
      if (productData.has_selling_plans) {
        // Dibs supplies the selected plan; a native Shopify form preserves it.
        // Never silently convert a preorder to an ordinary order.
        if (!validPreorderSelection()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          toast('Please select a pre-order payment option before adding this item. If none appears, ordering is temporarily unavailable.');
        }
        return;
      }
      e.preventDefault();
      addCurrent(false);
    }, true);

    function submitPurchase(thenCheckout) {
      if (thenCheckout || (monoToggle && monoToggle.checked)) { addCurrent(thenCheckout); return; }
      if (productData.has_selling_plans) {
        // Use the same form and app controls for every purchase entry point.
        if (productForm && atcBtn && !atcBtn.disabled) productForm.requestSubmit(atcBtn);
      } else {
        addCurrent(thenCheckout);
      }
    }
    if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); submitPurchase(false); });
    if (buyNowBtn) buyNowBtn.addEventListener('click', function (e) { e.preventDefault(); submitPurchase(true); });

    updateUI();
  }

  /* ---------- product gallery ---------- */
  var galleryState = { active: 0, images: [], filtered: null };

  /* Colour-aware gallery (02.09.2026 rewrite).
     Photographs name their colourway in the alt text — in English, Polish,
     German or Italian — while option values may be in another language
     ("Black" vs "Czarny", "Burgundy" vs "Burgund"). Both sides are reduced to
     a canonical colour key before matching, so selecting a colour shows only
     that colour's shots: one colour per dot. The variant's own photo (if it
     has one) always comes first. If nothing matches, the full set is shown. */
  var COLOUR_SYNONYMS = {
    black: ['black', 'czarny', 'czarne', 'schwarz', 'nero'],
    graphite: ['graphite', 'grafitowy', 'grafit', 'graphit', 'grafite', 'charcoal', 'anthracite', 'antracyt'],
    slate: ['slate', 'łupkowy', 'schiefer', 'ardesia'],
    brown: ['brown', 'brązowy', 'braun', 'marrone'],
    tan: ['tan', 'saddle tan', 'cognac', 'koniakowy', 'cammello', 'saddle'],
    navy: ['navy', 'granatowy', 'marine', 'blau', 'blu'],
    burgundy: ['burgundy', 'burgund', 'bordowy', 'bordeaux', 'bordo'],
    olive: ['olive', 'oliwkowy', 'oliv', 'oliva'],
    espresso: ['espresso', 'chocolate', 'czekoladowy', 'schokolade', 'cioccolato'],
    terracotta: ['terracotta', 'terakota', 'terrakotta'],
    taupe: ['taupe'],
    ivory: ['ivory', 'kość słoniowa', 'kremowy', 'cream', 'elfenbein', 'avorio'],
    grey: ['grey', 'gray', 'szary', 'grau', 'grigio'],
    white: ['white', 'biały', 'weiß', 'bianco'],
    red: ['red', 'czerwony', 'rot', 'rosso'],
    green: ['green', 'zielony', 'grün', 'verde']
  };
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hasWord(text, term) {
    /* whole-word match that copes with accented letters; falls back to a
       plain substring test in browsers without Unicode property escapes */
    try {
      return new RegExp('(^|[^\\p{L}])' + escapeRe(term) + '(?=[^\\p{L}]|$)', 'iu').test(text);
    } catch (e) {
      return text.indexOf(term) !== -1;
    }
  }
  function colourKeys(text) {
    var t = String(text || '').trim().toLowerCase();
    if (!t) return [];
    return Object.keys(COLOUR_SYNONYMS).filter(function (key) {
      return COLOUR_SYNONYMS[key].some(function (w) { return hasWord(t, w); });
    });
  }
  function galleryApplyColour(colour, variantPos) {
    var imgs = galleryState.images;
    if (!imgs.length) return;
    var all = imgs.map(function (_, i) { return i; });
    var idx = all;
    var vi = variantPos > 0 ? variantPos - 1 : -1;
    if (vi >= imgs.length) vi = -1;
    var c = String(colour || '').trim().toLowerCase();
    if (c) {
      var keys = colourKeys(c);
      var key = keys.length ? keys[0] : null;
      var matched = [];
      imgs.forEach(function (im, i) {
        if (!im.keys) im.keys = colourKeys(im.alt);
        var alt = String(im.alt || '').toLowerCase();
        var hit = key ? im.keys.indexOf(key) !== -1 : false;
        /* unknown colour names: plain substring in either direction */
        if (!hit && !key && alt) hit = alt.indexOf(c) !== -1 || c.indexOf(alt) !== -1;
        var isPackaging = /gift box|packaging/i.test(alt);
if (hit || isPackaging) matched.push(i);
      });
      if (vi >= 0) {
        matched = [vi].concat(matched.filter(function (i) { return i !== vi; }));
      }
      if (matched.length) idx = matched;
    } else if (vi >= 0) {
      idx = [vi].concat(all.filter(function (i) { return i !== vi; }));
    }
    galleryState.filtered = idx;
    $$('[data-gallery-thumb]').forEach(function (t, j) {
      t.classList.toggle('hidden', idx.indexOf(j) === -1);
    });
    $$('[data-lightbox-thumb]').forEach(function (t, j) {
      t.classList.toggle('hidden', idx.indexOf(j) === -1);
    });
    gallerySet(idx[0]);
  }
  window.galleryApplyColour = galleryApplyColour;

  function galleryStep(delta) {
    var list = galleryState.filtered && galleryState.filtered.length
      ? galleryState.filtered
      : galleryState.images.map(function (_, i) { return i; });
    var pos = list.indexOf(galleryState.active);
    if (pos === -1) pos = 0;
    var next = ((pos + delta) % list.length + list.length) % list.length;
    gallerySet(list[next]);
  }

  function gallerySet(i) {
    var g = $('[data-gallery]');
    if (!g) return;
    var imgs = galleryState.images;
    if (!imgs.length) return;
    galleryState.active = ((i % imgs.length) + imgs.length) % imgs.length;
    var main = $('[data-gallery-main] img', g);
    var data = imgs[galleryState.active];
    if (main && data) {
      main.src = data.src;
      main.srcset = data.srcset || '';
      main.alt = data.alt || '';
    }
    $$('[data-gallery-thumb]', g).forEach(function (t, j) {
      t.setAttribute('aria-current', j === galleryState.active ? 'true' : 'false');
    });
    var counter = $('[data-lightbox-counter]');
    var total = galleryState.filtered && galleryState.filtered.length ? galleryState.filtered.length : imgs.length;
    var pos = galleryState.filtered && galleryState.filtered.length ? galleryState.filtered.indexOf(galleryState.active) + 1 : galleryState.active + 1;
    if (counter) counter.textContent = pos + '/' + total;
    var lbImg = $('[data-lightbox-img]');
    if (lbImg && data) { lbImg.src = data.zoom || data.src; lbImg.alt = data.alt || ''; }
    $$('[data-lightbox-thumb]').forEach(function (t, j) {
      t.setAttribute('aria-current', j === galleryState.active ? 'true' : 'false');
    });
  }

  function initGallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    galleryState.images = JSON.parse($('#GalleryJson').textContent);
    var main = $('[data-gallery-main]', g);
    var mainImg = main ? $('img', main) : null;

    if (main && mainImg) {
      main.addEventListener('mousemove', function (e) {
        var r = main.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      /* touch swipe: left/right browses images (within the active colour filter) */
      var touchX = 0, touchY = 0, touchLive = false;
      window.__lastGallerySwipe = 0;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { touchLive = false; return; }
        touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; touchLive = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!touchLive) return;
        touchLive = false;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          window.__lastGallerySwipe = Date.now();
          galleryStep(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
      main.addEventListener('click', function () {
        if (Date.now() - window.__lastGallerySwipe < 400) return;
        lightboxOpen();
      });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lightboxOpen(); }
      });
    }
    $$('[data-gallery-thumb]', g).forEach(function (t, i) {
      t.addEventListener('click', function () { gallerySet(i); });
    });
    $$('[data-gallery-prev]', g).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); galleryStep(-1); });
    });
    $$('[data-gallery-next]', g).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); galleryStep(1); });
    });

    /* lightbox */
    var lb = $('#GalleryLightbox');
    function lightboxOpen() {
      if (!lb) return;
      lb.dataset.open = 'true';
      document.body.classList.add('overflow-locked');
      gallerySet(galleryState.active);
    }
    function lightboxClose() {
      if (!lb) return;
      lb.dataset.open = 'false';
      document.body.classList.remove('overflow-locked');
      var frame = $('.lightbox__frame', lb);
      if (frame) { frame.classList.remove('zoomed'); $('[data-lightbox-img]', lb).style.transform = ''; }
    }
    if (lb) {
      $$('[data-lightbox-close]', lb).forEach(function (b) { b.addEventListener('click', lightboxClose); });
      $$('[data-lightbox-prev]', lb).forEach(function (b) { b.addEventListener('click', function () { galleryStep(-1); }); });
      $$('[data-lightbox-next]', lb).forEach(function (b) { b.addEventListener('click', function () { galleryStep(1); }); });
      $$('[data-lightbox-thumb]', lb).forEach(function (t, i) { t.addEventListener('click', function () { gallerySet(i); }); });
      var frame = $('.lightbox__frame', lb);
      var img = $('[data-lightbox-img]', lb);
      if (frame && img) {
        frame.addEventListener('click', function (e) {
          if (e.target.closest('button')) return;
          var zoomed = frame.classList.toggle('zoomed');
          img.style.transform = zoomed ? 'scale(2.2)' : '';
        });
        frame.addEventListener('mousemove', function (e) {
          if (!frame.classList.contains('zoomed')) return;
          var r = frame.getBoundingClientRect();
          img.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
        });
      }
      document.addEventListener('keydown', function (e) {
        if (lb.dataset.open !== 'true') return;
        if (e.key === 'Escape') lightboxClose();
        if (e.key === 'ArrowRight') galleryStep(1);
        if (e.key === 'ArrowLeft') galleryStep(-1);
      });
    }
  }

  /* ---------- modals (size guide) ---------- */
  function initModals() {
    $$('[data-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = $('#' + b.getAttribute('data-modal-open'));
        if (m) { m.dataset.open = 'true'; document.body.classList.add('overflow-locked'); }
      });
    });
    $$('.modal').forEach(function (m) {
      $$('[data-modal-close]', m).forEach(function (b) {
        b.addEventListener('click', function () { m.dataset.open = 'false'; document.body.classList.remove('overflow-locked'); });
      });
      var ov = $('.modal__overlay', m);
      if (ov) ov.addEventListener('click', function () { m.dataset.open = 'false'; document.body.classList.remove('overflow-locked'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.modal[data-open="true"]').forEach(function (m) {
        m.dataset.open = 'false'; document.body.classList.remove('overflow-locked');
      });
    });
  }

  /* ---------- quick add (product cards) ---------- */
  function initQuickAdd() {
    $$('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        cart.add(parseInt(b.getAttribute('data-quick-add'), 10), 1)
          .then(function () { return cart.refresh(); })
          .then(cart.open)
          .catch(function () { toast('Could not add to basket'); });
      });
    });
  }

  /* ---------- generic image lightbox (size guide etc.) ---------- */
  function initZoomables() {
    var triggers = $$('[data-zoomable]');
    if (!triggers.length) return;
    var overlay = document.createElement('div');
    overlay.className = 'img-lightbox';
    overlay.setAttribute('data-open', 'false');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    var closeLabel = triggers[0].getAttribute('data-close-label') || 'Close';
    overlay.innerHTML = '<button type="button" class="img-lightbox__close" aria-label="' + closeLabel + '">✕</button><img alt="">';
    document.body.appendChild(overlay);
    var img = overlay.querySelector('img');
    function close() {
      overlay.dataset.open = 'false';
      img.classList.remove('zoomed');
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === img) { img.classList.toggle('zoomed'); return; }
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.dataset.open === 'true') close();
    });
    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        img.src = el.getAttribute('data-zoom-src') || el.currentSrc || el.src;
        img.alt = el.alt || '';
        overlay.dataset.open = 'true';
      });
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.dataset.show = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.dataset.show = 'false'; }, 3000);
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal(document);
    initMobileMenu();
    initCartTriggers();
    bindCartDrawer();
    initGallery();
    initProductForm();
    initModals();
    initZoomables();
    initQuickAdd();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();